import axios from "axios";

// Use the current origin in production so the API works on any domain
// (e.g. salside.com, custom domains, etc.). Falls back to env var only
// if the env var domain matches the current host.
const ENV_URL = process.env.REACT_APP_BACKEND_URL || "";
const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

let resolvedBase = ENV_URL;
try {
  if (ORIGIN && ENV_URL && new URL(ENV_URL).host !== new URL(ORIGIN).host) {
    // Mismatch between baked env URL and the actual served host → use the
    // current origin so API calls hit the right backend.
    resolvedBase = ORIGIN;
  }
  if (!resolvedBase) resolvedBase = ORIGIN;
} catch {
  resolvedBase = ORIGIN || ENV_URL;
}

const BACKEND_URL = resolvedBase;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Add token from localStorage as fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("salside_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
